import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { updatePackTopics, resolvePackByRoute } from "../registry";

/**
 * Risolve il topic contestuale corrente per il Pack indicato.
 * All'inizializzazione recupera dal backend la mappa route→topic aggiornata
 * (SSoT server-side) e la fonde nel registro locale.
 *
 * Ritorna il topic risolto per la route corrente (o l'ultima route "utile"
 * memorizzata prima di navigare al Centro Guida).
 */
export function useGuideContext(appKey, currentPath, referrerPath) {
  const [ready, setReady] = useState(false);
  const [topic, setTopic] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/guide/topics", { params: { app: appKey } })
      .then(({ data }) => {
        if (cancelled) return;
        updatePackTopics(appKey, data?.route_topics || {});
      })
      .catch(() => { /* fallback: topic mapping locale */ })
      .finally(() => { if (!cancelled) setReady(true); });
    return () => { cancelled = true; };
  }, [appKey]);

  useEffect(() => {
    if (!ready) return;
    // Priorita': referrer esplicito -> path corrente (esclusa /guida)
    let usedPath = referrerPath;
    if (!usedPath && currentPath && !currentPath.startsWith("/guida")) {
      usedPath = currentPath;
    }
    const t = resolvePackByRoute(appKey, usedPath);
    setTopic(t);
  }, [ready, appKey, currentPath, referrerPath]);

  return { topic, ready };
}
